<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Movimenti Magazzino</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="toggleFilters">
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'giacenze-magazzino' })"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="show_filters">
          <v-col cols="2">
            <v-row>
              <v-col>
                <v-menu
                  ref="menu-da"
                  v-model="menu_da"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      readonly
                      v-model="data_start_formatted"
                      label="Da"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data_start"
                    no-title
                    locale="it"
                    @input="menu_da = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  ref="menu-a"
                  v-model="menu_a"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      readonly
                      v-model="data_end_formatted"
                      label="A"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data_end"
                    no-title
                    locale="it"
                    @input="menu_a = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Causale"
              dense
              v-model="causaleSel"
              :items="causali"
              item-text="des"
              item-value="val_int"
            >
              <template v-slot:append>
                <v-btn icon small @click="causaleSel = null">
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              label="Utente"
              dense
              v-model="user"
              :items="users"
              item-text="nominativo"
              item-value="id_utente"
            >
              <template v-slot:append>
                <v-btn icon small @click="user = null">
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              label="Seriale"
              dense
              v-model="seriale"
              :items="lista_tabella.filter((e) => e.sotto_lotto != null)"
              item-text="sotto_lotto"
              item-value="sotto_lotto"
            >
              <template v-slot:append>
                <v-btn icon small @click="seriale = null">
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              label="Cod. Lotto"
              dense
              v-model="codice_lotto"
              :items="lista_tabella.filter((e) => e.cod_lotto != null)"
              item-text="cod_lotto"
              item-value="cod_lotto"
            >
              <template v-slot:append>
                <v-btn icon small @click="codice_lotto = null">
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="auto">
            <v-btn small @click="callList">
              <v-icon color="primary">mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="
                lista_tabella?.filter(
                  (e) => codice_lotto == null || e.cod_lotto == codice_lotto
                )
              "
              height="60vh"
            >
              <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="rettificaRiga(item)"
                    >
                      <v-icon color="#1a80b6">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Rettifica Movimento</span>
                </v-tooltip>
              </template>

              <!-- Colonna della ragione sociale -->
              <template v-slot:[`item.ragione_sociale`]="{ item }">
                {{
                  item.ragione_sociale == null || item.ragione_sociale == ""
                    ? "N/D"
                    : item.ragione_sociale
                }}
              </template>

              <template v-slot:[`item.ristampa`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="RistampaReport(item)"
                    >
                      <v-icon color="primary">mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>Ristampa Report</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.posizione`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="openPosizioneMagazzino(item)"
                    >
                      <v-icon color="#1a80b6">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Dettaglio posizione</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-if="currentItem"
      v-model="posizione_magazzino_visible"
      width="800"
    >
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text"> Posizione </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="posizione_magazzino_visible = false"
                small
              >
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-0 pt-3">
          <v-container>
            <v-row>
              <v-col cols="6">
                <div class="text-h5">Magazzino partenza</div>
                <v-subheader class="px-0">{{
                  currentItem.posizionepartenza
                }}</v-subheader>
              </v-col>
              <v-col cols="6">
                <div class="text-h5">Magazzino arrivo</div>
                <v-subheader class="px-0">{{
                  currentItem.posizionearrivo
                }}</v-subheader>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <div class="text-h5">Utente</div>
                <v-subheader class="px-0">{{
                  currentItem.des_utente
                }}</v-subheader>
              </v-col>
              <v-col cols="6">
                <div class="text-h5">Data</div>
                <v-subheader class="px-0">{{ currentItem.data }}</v-subheader>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_nuovo_movimento" persistent>
      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQVRettifica" />
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Nuovo Movimento
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="showConfermaMovimento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva Rettifica</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_nuovo_movimento = false" small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="overflow-y: auto" class="mt-5">
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field label="sede" dense hide-details readonly>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Magazzino"
                  :value="magazzini[id_magazzino]"
                  readonly
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Posizione Magazzino"
                  dense
                  hide-detail
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="tempMovimento.cod_articolo"
                  id="codiceAutocomplete"
                  label="Codice Articolo"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  id="descrizioneArticolo"
                  label="Descrizione Articolo"
                  v-model="tempMovimento.des_articolo"
                  readonly
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Codice Documento"
                  v-model="tempMovimento.num_documento"
                  readonly
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Lotto"
                  v-model="tempMovimento.cod_lotto"
                  dense
                  hide-details
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Seriale"
                  v-model="tempMovimento.numero_seriale"
                  dense
                  hide-details
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  readonly
                  v-model="tempMovimento.data_scadenza"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  label="Causale Movimento"
                  :items="causali.filter((e) => e.bloccato !== 1)"
                  item-text="des"
                  item-value="id_tabella"
                  v-model="tempMovimento.causale"
                >
                  <template #label class="mb-3">
                    <span>Causale Movimento</span>
                    <span @click.stop style="pointer-events: all">
                      <Modules
                        v-on:dialogModules="getTabelle"
                        tipo="CAUSALI_MAGAZZINO_MOVIMENTI"
                        nome="Causale Movimento"
                        setaction="settabella"
                        getaction="gettabella"
                        controller="Global"
                        :filter="'validita = 1'"
                        :dati="[{ des: '' }]"
                      />
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Quantità"
                  v-model="tempMovimento.quantita"
                  dense
                  type="number"
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Note"
                  outlined
                  v-model="tempMovimento.note"
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_conferma_movimento" persistent width="500">
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Conferma Rettifica
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-3" style="overflow-y: auto">
          <v-container>
            <v-row>
              <v-col cols="12">
                <span style="font-size: 18px">
                  Sei sicuro di voler eseguire il movimento per l'articolo
                  <b>{{ tempMovimento.cod_articolo }}</b> ?
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span style="font-size: 18px">
                  Una volta confermati, i movimenti NON possono più essere
                  modificati.
                </span>
              </v-col>
            </v-row>

            <v-divider class="my-5"></v-divider>

            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-btn class="mr-10" @click="annullaMovimento">
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
                <v-btn @click="confermaMovimento">
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pdfdialog" width="unset" content-class="pdfdialog">
      <v-card>
        <v-toolbar
          class="white--text"
          color="blue"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title> Stampa Pdf </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="red--text"
            @click="pdfdialog = false"
            color="blue-grey lighten-5"
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row>
          <v-col cols="12" sm="6" md="12">
            <iframe
              :src="selected_pdf"
              frameborder="0"
              style="height: 90vh !important; width: 90vw !important"
            >
            </iframe>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "MovimentiMagazzino",

  components: {
    Modules: () => import("@/components/TOOLS/Modules.vue"),
    SnackbarQV,
  },

  props: ["id_magazzino", "id_articolo"],
  data() {
    return {
      // Variabili di supporto
      currentItem: null,
      loading: false,
      show_filters: true,
      posizione_magazzino_visible: false,
      menu_a: false,
      menu_da: false,
      codice_articolo: null,
      codice_lotto: null,
      descrizione_articolo: null,
      data_start: null,
      data_end: null,
      data_start_formatted: null,
      data_end_formatted: null,
      selected_pdf: null,
      seriale: null,
      user: null,

      // Modals
      dialog_nuovo_movimento: false,
      dialog_conferma_movimento: false,
      pdfdialog: false,
      snackbarSalvato: false,
      snackbarAnnullato: false,
      cercaCodice: false,

      // Array
      sedi: [],
      magazzini: ["...", "WIP", "SCARTO"],
      posizioni: [],
      catagorie: [],
      articoli: [],
      direzioni: [],
      causali: [],
      causaleSel: null,
      headers: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Ristampa",
          value: "ristampa",
          sortable: false,
        },
        {
          text: "Posizione",
          value: "posizione",
          sortable: false,
        },
        {
          text: "Data",
          value: "data",
        },
        {
          text: "Data Scadenza",
          value: "data_scadenza",
          sortable: false,
        },
        {
          text: "Cod. articolo",
          value: "cod_articolo",
        },
        {
          text: "Des. Articolo",
          value: "des_articolo",
        },
        {
          text: "Fornitore",
          value: "ragione_sociale",
        },
        {
          text: "Num. Documento",
          value: "num_documento",
        },
        {
          text: "Causale",
          value: "des_causale_magazzino",
        },
        {
          text: "Lotto Esterno",
          value: "lotto_fornitore",
        },
        {
          text: "Cod. Lotto",
          value: "cod_lotto",
        },
        {
          text: "Seriale",
          value: "sotto_lotto",
        },
        {
          text: "Q.tà",
          value: "quantita",
        },
        {
          text: "Ubicazione",
          value: "des_dettaglio",
        },
        {
          text: "Utente",
          value: "des_utente",
        },
        {
          text: "Note",
          value: "note",
          sortable: false,
        },
      ],
      lista_tabella: [],
      movimentiMagazzino: [],
      users: [],

      tempMovimento: {
        causale: "",
        cod_lotto: "",
        data: "",
        data_documento: "",
        data_documento1: "",
        des_documento: "",
        id_magazzino: "",
        lotto_fornitore: "",
        num_documento: "",
        num_documento1: "",
        quantita: "",
        ragione_sociale: "",

        des_utente: "",
        sede: "",
        posizione: "",
        cod_articolo: "",
        des_articolo: "",
        direzione: "",
        catagoria: "",
        note: "",
        id: "",

        validita: 1,
      },
    };
  },
  watch: {
    data_start(val) {
      this.data_start_formatted = this.formatDate(val);
    },
    data_end(val) {
      this.data_end_formatted = this.formatDate(val);
    },
  },
  computed: {},
  mounted() {
    this.data_start = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.data_end = moment().format("YYYY-MM-DD");

    this.callList();
    this.getTabelle();
    this.getUtenti();
  },

  methods: {
    getTabelle() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "CAUSALI_MAGAZZINO_MOVIMENTI",
          filter: "validita = 1",
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            this.causali = Array.from(res.data);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });
    },
    rettificaRiga(arg) {
      console.log(JSON.stringify(arg));
      this.tempMovimento = Object.assign({}, arg);
      this.tempMovimento.causale = null;
      this.dialog_nuovo_movimento = true;
    },
    RistampaReport(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "ristampareport",
          tipo_report: "SERIALE",
          id_magazzino_movimenti: arg.id_magazzino_movimenti,
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          // Gestione delle snackbar di avviso di Alberto.
          if (res.status == 200) {
            // Gestione delle snackbar di avviso di Alberto.
            if (
              "tipo_messaggio" in res.data &&
              "query_messaggio" in res.data &&
              res.data.tipo_messaggio == 1
            ) {
              this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
            }

            // Logica di business.
            const byteCharacters = atob(res.data.result.result);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            this.selected_pdf = blobUrl;
            this.pdfdialog = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Impossibile generare la stampa."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Impossibile generare la stampa."
            );
          }
          return false;
        });
    },

    async callList() {
      this.loading = true;
      this.movimentiMagazzino = [];

      await this.getArticolo();

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolomovimentimagazzino",
          token: localStorage.user_token,
          id_articolo: this.id_articolo,
          id_magazzino: this.id_magazzino,
          data_da: this.data_start,
          data_a: this.data_end,
          id_causale: this.causaleSel === null ? "" : this.causaleSel,
          id_utente: this.user === null ? "" : this.user,
          numero_seriale: this.seriale === null ? "" : this.seriale,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.movimentiMagazzino = res.data;

        this.movimentiMagazzino.forEach((item) => {
          item.cod_articolo = this.codice_articolo;
          item.des_articolo = this.descrizione_articolo;
        });

        this.lista_tabella = this.movimentiMagazzino;

        this.loading = false;
      });
    },
    getArticolo() {
      return new Promise((resolve) => {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticoli",
            token: localStorage.user_token,
            id_articolo: this.id_articolo,
          },
        };
        this.$store.dispatch("api", request).then((res) => {
          this.codice_articolo = res.data.articolo[0].cod_articolo;
          this.descrizione_articolo = res.data.articolo[0].des_articolo;
          resolve();
        });
      });
    },
    getUtenti() {
      let getUtenteList = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", getUtenteList)
        .then((res) => {
          if (res.status === 200) {
            this.users = new Array();
            this.users = Array.from(res.data);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    openPosizioneMagazzino(item) {
      this.currentItem = item;
      this.posizione_magazzino_visible = true;
    },
    toggleFilters() {
      this.show_filters = !this.show_filters;
    },

    nuovoMovimento() {
      this.dialog_nuovo_movimento = true;
    },

    showConfermaMovimento() {
      // Controllo che i campi necessari siano stati valorizzati
      if (
        this.tempMovimento.quantita === 0 ||
        this.tempMovimento.quantita === null
      ) {
        this.$refs.SnackbarQVRettifica.print(
          "orange",
          "La quantità di rettifica deve essere presente e diversa da zero."
        );
        return;
      }

      if (this.tempMovimento.causale === null) {
        this.$refs.SnackbarQVRettifica.print(
          "orange",
          "La causale di rettifica deve essere specificata."
        );
        return;
      }

      if (
        this.tempMovimento.note === null ||
        this.tempMovimento.note === undefined ||
        this.tempMovimento.note === ""
      ) {
        this.$refs.SnackbarQVRettifica.print(
          "orange",
          "Il campo Note deve essere compilato."
        );
        return;
      }

      this.dialog_conferma_movimento = true;
    },

    annullaMovimento() {
      this.dialog_conferma_movimento = false;
      this.$refs.SnackbarQV.print(
        "error",
        "Movimento di magazzino non salvato"
      );
    },

    confermaMovimento() {
      this.dialog_conferma_movimento = false;
      var dataAttuale = new Date();
      this.tempMovimento.data =
        dataAttuale.getDay() +
        "/" +
        dataAttuale.getMonth() +
        "/" +
        dataAttuale.getFullYear() +
        " " +
        dataAttuale.getHours() +
        ":" +
        dataAttuale.getMinutes() +
        ":" +
        dataAttuale.getSeconds();

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setrettificamagazzino",
          token: localStorage.user_token,
          quantita: this.tempMovimento.quantita,
          id_causale_magazzino: this.tempMovimento.causale,
          id_magazzino_movimenti: this.tempMovimento.id_magazzino_movimenti,
          note: this.tempMovimento.note,
        },
      };

      // console.log(JSON.stringify(request));

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_nuovo_movimento = false;
            this.$refs.SnackbarQV.print(
              "success",
              "Movimento di magazzino salvato correttamente"
            );
            this.callList();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        });
    },

    searchArticolo() {
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: document.getElementById("codiceAutocomplete").value,
        },
      };
      this.$store.dispatch("api", search_Articolo).then((res) => {
        this.articoli = [];
        this.descizioni = [];
        res.data.lista.forEach((e) => {
          this.$set(this.articoli, this.articoli.length, {
            codice: e["cod_articolo"],
            descrizione: e["des_articolo"],
          });
        });
      });
    },
  },
};
</script>